import React, { useEffect } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { MESSAGE, TYPE, URL } from '../../../../constant';
import { useAlert, useUserInfo } from '../../../../hooks';
import A from '../../../common/A';

function PwInquirySuccess() {
  const [Alert] = useAlert();
  const { info } = useUserInfo();
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const { state } = location;
    if (!state?.email) {
      Alert(
        MESSAGE.INVALID_ACCESS,
        () => history.push(URL.ACCOUNT.PW_INQUIRY),
        "msg005"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <div className={clsx(
        "header_top",
        info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'gb' : ''
      )}>
        <div className="inner">
          {
            info.channelCode === TYPE.CHANNEL.GLOBAL01
             ? (
              <div className="btns_wrap cls">
                <div className="app_btn">
                  <button className="btn_exit" type="button" onClick={() => history.goBack()}>
                    <img src="./static/images/icon/btn_back.svg" alt="" />
                  </button>
                </div>
                <div className="tit_gm center_tit24">{t("MY_01_01.msg001")}</div>
              </div>
             )
             : (
              <div className="btns_wrap header-trans">
                <div className="login cls">
                  <A onClick={() => history.push(URL.ACCOUNT.PW_INQUIRY)}>{t("MY_01_01.msg001")}</A>
                </div>
              </div>
             )
          }
        </div>
      </div>
      <div className={clsx(
        "layout-def log_in pw_send ",
        info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'gb' : 'with_bottom_area'
      )}>
        <div className="container">
          <div className="inner">
            <div className="center_wrap">
              <div className="logo_wrap">
                <div className="logo">
                  <img src="./static/images/common/img_send@2x.png" alt="" />
                </div>
              </div>
              <div className="noti_wrap">
                <div 
                  className="noti1" 
                  dangerouslySetInnerHTML={{ __html: t("MY_01_01.msg002", { email: location.state?.email})}}
                />
                <div 
                  className="noti2" 
                  dangerouslySetInnerHTML={{ __html: t("MY_01_01.msg003")}}
                />
              </div>
            </div>
            <div className={clsx(
              "bottom_wrap btn_wrap",
              info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'static' : ''
            )}>
              <A
                className="btn btn-white"
                onClick={() => history.push(URL.ACCOUNT.LOGIN)}
              >
                {t("MY_01_01.msg004")}
              </A>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PwInquirySuccess;